import { render, staticRenderFns } from "./Replenishmentinfo.vue?vue&type=template&id=ffa15ea8&scoped=true&"
import script from "./Replenishmentinfo.vue?vue&type=script&lang=js&"
export * from "./Replenishmentinfo.vue?vue&type=script&lang=js&"
import style0 from "./Replenishmentinfo.vue?vue&type=style&index=0&id=ffa15ea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa15ea8",
  null
  
)

export default component.exports